import { render, staticRenderFns } from "./ShowDia.vue?vue&type=template&id=3a039c15&scoped=true"
import script from "./ShowDia.vue?vue&type=script&lang=js"
export * from "./ShowDia.vue?vue&type=script&lang=js"
import style0 from "./ShowDia.vue?vue&type=style&index=0&id=3a039c15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a039c15",
  null
  
)

export default component.exports